//Accessibility
function addMailtoConfirm() {
	const mailtoLinks = document.querySelectorAll('a[href^="mailto:"]');
	mailtoLinks.forEach((link) => {
		// Avoid adding multiple listeners
		if (!link.dataset.confirmAdded) {
			// Add click confirmation
			link.addEventListener("click", function (e) {
				if (!confirm("This link will open your email client. Continue?")) {
					e.preventDefault();
				}
			});

			// Inject sr-only span for screen readers if not already present
			if (!link.querySelector(".sr-only")) {
				const srSpan = document.createElement("span");
				srSpan.className = "sr-only";
				srSpan.textContent = " (opens your email client)";
				link.appendChild(srSpan);
			}

			// Remove title attribute if present
			if (link.hasAttribute("title")) link.removeAttribute("title");

			// Mark as processed
			link.dataset.confirmAdded = "true";
		}
	});
}

function addPdfConfirm() {
	const pdfLinks = document.querySelectorAll('a[href$=".pdf"]');
	pdfLinks.forEach((link) => {
		if (!link.dataset.confirmAdded) {
			link.addEventListener("click", function (e) {
				if (!confirm("This link will open a PDF document. Continue?")) {
					e.preventDefault();
				}
			});

			if (!link.querySelector(".sr-only")) {
				const srSpan = document.createElement("span");
				srSpan.className = "sr-only";
				srSpan.textContent = " (opens a PDF document)";
				link.appendChild(srSpan);
			}

			if (link.hasAttribute("title")) link.removeAttribute("title");
			link.dataset.confirmAdded = "true";
		}
	});
}

function addVideoConfirm() {
	const videoLinks = document.querySelectorAll('a[href$=".mp4"]');
	videoLinks.forEach((link) => {
		if (!link.dataset.confirmAdded) {
			link.addEventListener("click", function (e) {
				if (!confirm("This link will open a video file. Continue?")) {
					e.preventDefault();
				}
			});

			if (!link.querySelector(".sr-only")) {
				const srSpan = document.createElement("span");
				srSpan.className = "sr-only";
				srSpan.textContent = " (opens a video file)";
				link.appendChild(srSpan);
			}

			if (link.hasAttribute("title")) link.removeAttribute("title");
			link.dataset.confirmAdded = "true";
		}
	});
}

// Run after DOM loads
document.addEventListener("DOMContentLoaded", function () {
	addMailtoConfirm();
	addPdfConfirm();
	addVideoConfirm();

	// Ensure all iframes have a title
	document.querySelectorAll("iframe:not([title])").forEach(function (iframe) {
		iframe.setAttribute("title", "Embedded content");
	});
});

document.addEventListener("DOMContentLoaded", function () {
	// Find all links that act as submenu toggles
	const submenuLinks = document.querySelectorAll('a[aria-haspopup="true"]');

	submenuLinks.forEach((link) => {
		const submenu = link.nextElementSibling; // <ul class="level-3-menu">
		if (!submenu) return;

		// Set initial hidden state for screen readers
		submenu.setAttribute("aria-hidden", "true");

		// Toggle on click
		link.addEventListener("click", function (e) {
			e.preventDefault(); // Prevent navigating if it’s a toggle

			const isExpanded = link.getAttribute("aria-expanded") === "true";
			link.setAttribute("aria-expanded", String(!isExpanded));
			submenu.setAttribute("aria-hidden", String(isExpanded));
		});

		// Keyboard accessibility
		link.addEventListener("keydown", function (e) {
			if (e.key === "Enter" || e.key === " ") {
				e.preventDefault();
				link.click();
			}
		});
	});
});

function toggleMenu(event, el) {
	event.preventDefault(); // prevent navigation if link has submenu
	const submenu = el.nextElementSibling;
	const expanded = el.getAttribute("aria-expanded") === "true";
	el.setAttribute("aria-expanded", !expanded);
	if (submenu) submenu.classList.toggle("hidden");
}

(function () {
	const header = document.getElementById("header");
	if (!header) return;

	function updateHeaderOffset() {
		const height = header.offsetHeight;

		// For anchor links & focus scroll
		document.documentElement.style.scrollPaddingTop = height + "px";

		// Optional: expose as CSS variable if needed elsewhere
		document.documentElement.style.setProperty(
			"--header-offset",
			height + "px",
		);
	}

	// Run on load
	updateHeaderOffset();

	// Recalculate on resize (responsive header height)
	window.addEventListener("resize", updateHeaderOffset);

	// Recalculate if fonts/images affect header size
	window.addEventListener("load", updateHeaderOffset);
})();

//Strip the gl_
(function () {
	const url = new URL(window.location.href);

	if (url.searchParams.has("_gl")) {
		url.searchParams.delete("_gl");

		window.history.replaceState(
			{},
			document.title,
			url.pathname + url.search + url.hash,
		);
	}
})(); 
